export default __webpack_public_path__ + "static/media/confirmation-portals.a5969ff0.png";